import React, { useEffect, useState } from 'react';
import axios from "axios";
import BlogSingleItem from '../../../components/BlogSingleItem/BlogSingleItem';
import VideoPopup from '../../../components/VideoPopup/VideoPopup';
import BlogLeftSideBar from './BlogLeftSideBar';

const BlogsArea = () => {
   const [newsUpdates, setNewsUpdates] = useState([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);

   const removeHtmlTags = (htmlContent) => {
      return htmlContent.replace(/<\/?[^>]+(>|$)/g, "");
   };

   const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(date);
      const month = new Intl.DateTimeFormat("en-GB", { month: "short" }).format(date);
      const year = new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(date);
      return { day, month, year };
   };

   useEffect(() => {
      const fetchNewsUpdates = async () => {
         try {
            const response = await axios.get(
               `${process.env.REACT_APP_API_URL}/blogs/`
            );

            const cleanedData = response.data.map((item) => ({
               ...item,
               content: truncateText(removeHtmlTags(item.content), 200),
               created: formatDate(item.created),
            }));
            setNewsUpdates(cleanedData);
            setLoading(false);
         } catch (err) {
            setError(err.message);
            setLoading(false);
         }
      };

      fetchNewsUpdates();
   }, []);

   const truncateText = (text, maxLength) => {
      if (text.length <= maxLength) {
         return text;
      }
      return text.substring(0, maxLength) + "...";
   };

   if (loading) return <div>Loading...</div>;
   if (error) return <div>Error: {error}</div>;

   return (
      <>
         <VideoPopup videoId="yJg-Y5byMMw" />

         <section className="blog__area pt-120 pb-120">
            <div className="tw-container tw-mx-auto">
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  <div className="tw-w-full tw-px-3 lg:tw-w-2/3">
                     <div className="blog__wrapper mr-50">
                        {newsUpdates.map((news, i) => (
                           <BlogSingleItem key={i} id={news.id} image={news.image} user_image="1" name="Harsoft" title={news.title} content={news.content} day={news.created.day} month={news.created.month} year={news.created.year} />
                        ))}

                     </div>
                  </div>

                  <BlogLeftSideBar />
               </div>
            </div>
         </section>
      </>
   );
};

export default BlogsArea;